import PermissionList from '@/configs/permissionList'
import PermissionMapper from '../configs/permission-mapper'
/**
 * @description 生成侧边导航栏
 * @param {permissionList} 权限列表
 */
export const createMenuList = (list) => {
  const perm = []
  PermissionList.forEach(fItem => {
    list.forEach(item => {
      if (fItem.name === item.name) {
        perm.push({
          name: fItem.name
        })
      }
    })
  })

  PermissionList.forEach(fItem => {
    if (fItem.children && fItem.children.length) {
      list.forEach((item, index) => {
        if (item.name === fItem.name) {
          let _index = findIndex(perm, fItem.name)
          perm[_index].children = []
          item.children.forEach(item => {
            perm[_index].children.push({
              name: item.name
            })
          })
        }
      })
    }
  })


  function findIndex(target, val){
    let Index = null;
    target.forEach((item, index) => {
      if(item.name === val){
        Index = index
      }
    })
    return Index
  }

  const sideMemuList = []
  perm.forEach(item => {
    const menuItem = PermissionMapper.get(item.name)
    if (item.children && Array.isArray(item.children) && item.children.length) {
      const { children } = item

      if (item.name === '企业服务管理' && item.children && item.children.length) {
        item.children.forEach((label, i)=> {
          if (label.name === '分类管理'){
            item.children[i].name = '企业分类管理'
          }
        })
      }
      menuItem.children = []
      children.forEach((subValue) => {
        const item = PermissionMapper.get(subValue.name)

        if (item.name === '企业分类管理'){
          item.name = '分类管理'
        }
        if (item) {
          menuItem.children.push(item)
        }
      })
    }
    if (menuItem) {
      sideMemuList.push(menuItem)
    }
  })
  return sideMemuList
}

